const COMPANY_TYPES = {
	COMPANY: "COMPANY",
	CONSORTIUM: "CONSORTIUM",
	BUSINESS_UNIT: "BUSINESS_UNIT",
};

export { COMPANY_TYPES as default };
